import { DefaultButton, Dialog, DialogFooter, DialogType, IRefObject, ITextField, PrimaryButton, Stack, TextField } from "@fluentui/react";
import React, { useEffect, useRef, useState } from "react";

interface ICommentDialogProps {
    isOpen: boolean;
    onDismiss?: () => void;
    onConfirm?: (note: string) => void;
    softDismiss?: boolean;
    defaultValue?: string;
}

const CommentDialog: React.FunctionComponent<ICommentDialogProps> = (props) => {
    const [dv, setDB] = useState<string | undefined>(props.defaultValue);
    const refTextField = useRef<ITextField>(null);

    useEffect(() => {
        if (props.isOpen)
            setDB(props.defaultValue);

    }, [props.isOpen])

    return <Dialog
        minWidth={600}
        hidden={!props.isOpen}
        onDismiss={props.onDismiss}
        dialogContentProps={{
            type: DialogType.largeHeader,
            title: 'Note',
        }}
        modalProps={{
            isBlocking: true,
            styles: { main: { maxWidth: 650 } },
        }}
    >
        <div style={{ paddingBottom: '15px' }}>
            <Stack tokens={{ childrenGap: '15px' }}>
                <TextField
                    label="Note"
                    componentRef={refTextField}
                    onChange={(event, newValue) => {
                    }}
                    multiline
                    rows={5}
                    autoAdjustHeight={true}
                    defaultValue={dv}
                />
            </Stack>
        </div>

        <DialogFooter>

            <PrimaryButton
                text="Save"
                maxLength={2000}
                onClick={async () => {
                    const uncontrolledValue = refTextField?.current?.value ?? '';
                    props.onConfirm?.(uncontrolledValue);
                }}
            />

            <DefaultButton
                text="Cancel"
                onClick={() => {
                    props.onDismiss?.();
                }}
            />
        </DialogFooter>
    </Dialog>;
}

export default CommentDialog;